import { connect } from '@atlassian/jira-react-redux';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import LimitMessage from '@atlassian/jira-servicedesk-common/src/ui/components/limit-message';
import { maybeRuleSetIds } from '../../../state/selectors/rulesets';
import type { State } from '../../../state/types';
import RuleLimitMessage from './view';

const mapStateToProps = (state: State) => ({
	numRules: maybeRuleSetIds(state)
		// @ts-expect-error - TS7006 - Parameter 'rules' implicitly has an 'any' type.
		.map((rules) => rules.length)
		.orSome(0),
	LimitMessageComponent: LimitMessage,
});

const mapDispatchToProps = () => ({
	onContactSupportClicked: () => {
		triggerAnalyticsEvent('summary.header.rule-limit-message.contact-support');
	},
	onMessageRendered: () => {
		triggerAnalyticsEvent('summary.header.rule-limit-message.rendered');
	},
});

// @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Props>>' is not assignable to parameter of type 'ComponentType<Matching<Partial<Props>, WithIntlProps<Props>>>'.
export default connect(mapStateToProps, mapDispatchToProps)(RuleLimitMessage);
